import "./dashboard.css";
import "./leftbar.css";

import ApartmentIcon from "@mui/icons-material/Apartment";
import AssignmentIndIcon from "@mui/icons-material/AssignmentInd";
import DownloadIcon from "@mui/icons-material/Download";
import GavelIcon from "@mui/icons-material/Gavel";
import HomeIcon from "@mui/icons-material/Home";
import MenuIcon from "@mui/icons-material/Menu";
import WorkspacesIcon from "@mui/icons-material/Workspaces";
import DocumentScannerIcon from '@mui/icons-material/DocumentScanner';
import {
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import MuiAppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import Divider from "@mui/material/Divider";
import MuiDrawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import { styled } from "@mui/material/styles";
import Toolbar from "@mui/material/Toolbar";
import React from "react";
import { NavLink, Route, Routes } from "react-router-dom";

import UserProfileDropdown from "../components/UserProfileDropdown";
import allowedRoll from "../utills/allowedRoll";
import ProtectedRoutes from "../utills/ProtectedRoutes";
import ArbitatorSave from "../views/arbitrator/ArbitatorSave";
import ArbitratorCrud from "../views/arbitrator/ArbitratorCrud";
import Arbitrators from "../views/arbitrator/ArbitratorList";
import ViewArbitrator from "../views/arbitrator/ViewArbitrator";
import AssignArbitrator from "../views/Assignments/AssignArbitrator";
import Assignments from "../views/Assignments/Assignments";
import SingleAssignment from "../views/Assignments/SingleAssignment";
import EnterpriseCrud from "../views/Enterpise/EnterpriseCrud";
import EnterpriseList from "../views/Enterpise/EnterpriseList";
import EnterpriseSave from "../views/Enterpise/EnterpriseSave";
import ViewEnterpise from "../views/Enterpise/ViewEnterpise";
import Home from "../views/home/Home";
import MyDownloads from "../views/ops-automation/MyDownloads";
import ToolList from "../views/ops-automation/ToolList";
import Preview from "../views/Templates/Template";
import AddTemplate from "../views/Templates/AddTemplate";
import EditTemplate from "../views/Templates/EditTemplate";

const drawerWidth = 240;

const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: "hidden",
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up("sm")]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
});

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  ...(open && {
    ...openedMixin(theme),
    "& .MuiDrawer-paper": openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    "& .MuiDrawer-paper": closedMixin(theme),
  }),
}));

export default function Dashboard() {
  const [open, setOpen] = React.useState(true);
  return (
    <Box sx={{ display: "-webkit-box" }}>
      <CssBaseline />
      <AppBar className="Mui-Header-Custom"  position="fixed" open={open}>
        <Toolbar
          className="header-tab"
          style={{
            margin: open && "0px 24px 0px 24px",
          }}
        >
          <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={() => {
              setOpen(!open);
              if (open) {
                document.getElementById("logo-dashboard").style.display =
                  "none";
                document
                  .querySelectorAll(".menu-items")
                  .forEach(function (element) {
                    element.style.marginLeft = "10px";
                  });
              } else {
                document.getElementById("logo-dashboard").style.display =
                  "block";
                document
                  .querySelectorAll(".menu-items")
                  .forEach(function (element) {
                    element.style.marginLeft = "20px";
                  });
              }
            }}
            edge="start"
            sx={{
              marginRight: 5,
            }}
          >
            <MenuIcon style={{ color: "#000" }} />
          </IconButton>
          <UserProfileDropdown></UserProfileDropdown>
        </Toolbar>
      </AppBar>
      <Drawer
        variant="permanent"
        style={{ border: "none" }}
        className="left-navigation"
        open={open}
      >
        <DrawerHeader>
          <div className="topLeft">
            <img src="../../../img/logo.png" alt="" id="logo-dashboard" />
          </div>
        </DrawerHeader>
        <List style={{ marginTop: "1rem" }}>
          {allowedRoll("admin", "ops_user") !== true && (
            <ListItem
              className="menu-items"
              disablePadding
              sx={{ display: "block" }}
            >
              <NavLink to="/app/home" className="nav-links">
                <ListItemButton
                  style={{
                    minHeight: 48,
                    justifyContent: open ? "initial" : "center",
                  }}
                  className="left-menue-list-button"
                >
                  <ListItemIcon
                    sx={{
                      minWidth: 0,
                      mr: open ? 1 : "auto",
                      justifyContent: "center",
                    }}
                  >
                    <HomeIcon />
                  </ListItemIcon>
                  <ListItemText
                    primary={"Home"}
                    sx={{ opacity: open ? 1 : 0 }}
                  />
                </ListItemButton>
              </NavLink>
            </ListItem>
          )}
          {allowedRoll("admin") !== true && (
            <ListItem
              className="menu-items"
              disablePadding
              sx={{ display: "block" }}
            >
              <NavLink to="/app/assignments" className="nav-links">
                <ListItemButton
                  style={{
                    minHeight: 48,
                    justifyContent: open ? "initial" : "center",
                  }}
                  className="left-menue-list-button"
                >
                  <ListItemIcon
                    sx={{
                      minWidth: 0,
                      mr: open ? 1 : "auto",
                      justifyContent: "center",
                    }}
                  >
                    <AssignmentIndIcon />
                  </ListItemIcon>
                  <ListItemText
                    primary={"Assignments"}
                    sx={{ opacity: open ? 1 : 0 }}
                  />
                </ListItemButton>
              </NavLink>
            </ListItem>
          )}
          {allowedRoll("admin") !== true && (
            <ListItem
              className="menu-items"
              disablePadding
              sx={{ display: "block" }}
            >
              <NavLink to="/app/arbitrators" className="nav-links">
                <ListItemButton
                  style={{
                    minHeight: 48,
                    justifyContent: open ? "initial" : "center",
                  }}
                  className="left-menue-list-button"
                >
                  <ListItemIcon
                    sx={{
                      minWidth: 0,
                      mr: open ? 1 : "auto",
                      justifyContent: "center",
                    }}
                  >
                    <GavelIcon />
                  </ListItemIcon>
                  <ListItemText
                    primary={"Arbitrators"}
                    sx={{ opacity: open ? 1 : 0 }}
                  />
                </ListItemButton>
              </NavLink>
            </ListItem>
          )}
          {allowedRoll("admin") !== true && (
            <ListItem
              className="menu-items"
              disablePadding
              sx={{ display: "block" }}
            >
              <NavLink to="/app/enterprises" className="nav-links">
                <ListItemButton
                  style={{
                    minHeight: 48,
                    justifyContent: open ? "initial" : "center",
                  }}
                  className="left-menue-list-button"
                >
                  <ListItemIcon
                    sx={{
                      minWidth: 0,
                      mr: open ? 1 : "auto",
                      justifyContent: "center",
                    }}
                  >
                    <ApartmentIcon />
                  </ListItemIcon>
                  <ListItemText
                    primary={"Enterprises"}
                    sx={{ opacity: open ? 1 : 0 }}
                  />
                </ListItemButton>
              </NavLink>
            </ListItem>
          )}
          {allowedRoll("admin", "ops_user") !== true && (
            <ListItem
              className="menu-items"
              disablePadding
              sx={{ display: "block" }}
            >
              <NavLink to="/app/ops-automation-tools" className="nav-links">
                <ListItemButton
                  style={{
                    minHeight: 48,
                    justifyContent: open ? "initial" : "center",
                  }}
                  className="left-menue-list-button"
                >
                  <ListItemIcon
                    sx={{
                      minWidth: 0,
                      mr: open ? 1 : "auto",
                      justifyContent: "center",
                    }}
                  >
                    <WorkspacesIcon />
                  </ListItemIcon>
                  <ListItemText
                    primary={"Ops-Automation"}
                    sx={{ opacity: open ? 1 : 0 }}
                  />
                </ListItemButton>
              </NavLink>
            </ListItem>
          )}
          {allowedRoll("admin", "ops_user") !== true && (
            <ListItem
              className="menu-items"
              disablePadding
              sx={{ display: "block" }}
            >
              <NavLink to="/app/ops-automation-downloads" className="nav-links">
                <ListItemButton
                  style={{
                    minHeight: 48,
                    justifyContent: open ? "initial" : "center",
                  }}
                  className="left-menue-list-button"
                >
                  <ListItemIcon
                    sx={{
                      minWidth: 0,
                      mr: open ? 1 : "auto",
                      justifyContent: "center",
                    }}
                  >
                    <DownloadIcon />
                  </ListItemIcon>
                  <ListItemText
                    primary={"Downloads"}
                    sx={{ opacity: open ? 1 : 0 }}
                  />
                </ListItemButton>
              </NavLink>
            </ListItem>
          )}
             {allowedRoll("admin", "ops_user") !== true && (
            <ListItem
              className="menu-items"
              disablePadding
              sx={{ display: "block" }}
            >
              <NavLink to="/app/template" className="nav-links">
                <ListItemButton
                  style={{
                    minHeight: 48,
                    justifyContent: open ? "initial" : "center",
                  }}
                  className="left-menue-list-button"
                >
                  <ListItemIcon
                    sx={{
                      minWidth: 0,
                      mr: open ? 1 : "auto",
                      justifyContent: "center",
                    }}
                  >
                    <DocumentScannerIcon />
                  </ListItemIcon>
                  <ListItemText
                    primary={"Templates"}
                    sx={{ opacity: open ? 1 : 0 }}
                  />
                </ListItemButton>
              </NavLink>
            </ListItem>
          )}


        </List>
        <Divider></Divider>
      </Drawer>
      <Box component="main" sx={{ flexGrow: 1 }}>
        <div className="nav-view">
          <Routes>
            <Route
              element={<ProtectedRoutes allowedRoles={[2, 3, 4, 5, 7, 8, 9]} />}
            >
              <Route path="/dashboard/*" element={<Dashboard />} />
            </Route>
            <Route path="/home" element={<Home />} />

            <Route element={<ProtectedRoutes allowedRoles={["admin"]} />}>
              <Route path="/assignments" element={<Assignments />} />
            </Route>

            <Route element={<ProtectedRoutes allowedRoles={["admin"]} />}>
              <Route
                path="/assignments/assign-arbitrator"
                element={
                  <AssignArbitrator
                  // setResponseData={setResponse}
                  ></AssignArbitrator>
                }
              />
            </Route>
            <Route element={<ProtectedRoutes allowedRoles={["admin"]} />}>
              <Route
                path="/assignments/assignment"
                element={<SingleAssignment />}
              />
            </Route>

            <Route element={<ProtectedRoutes allowedRoles={["admin"]} />}>
              <Route path="/arbitrators" element={<Arbitrators />} />
            </Route>
            <Route element={<ProtectedRoutes allowedRoles={["admin"]} />}>
              <Route
                exact
                path="/arbitrator/create"
                element={<ArbitatorSave />}
              />
            </Route>
            <Route element={<ProtectedRoutes allowedRoles={["admin"]} />}>
              <Route
                path="/arbitrator/crud"
                element={<ArbitratorCrud></ArbitratorCrud>}
              />
            </Route>

            <Route element={<ProtectedRoutes allowedRoles={["admin"]} />}>
              <Route
                exact
                path="/arbitrators/arbitrator"
                element={<ViewArbitrator></ViewArbitrator>}
              ></Route>
            </Route>

            <Route element={<ProtectedRoutes allowedRoles={["admin"]} />}>
              <Route path="/enterprises" element={<EnterpriseList />} />
            </Route>

            <Route element={<ProtectedRoutes allowedRoles={["admin"]} />}>
              <Route
                exact
                path="/enterprises/crud"
                element={<EnterpriseCrud></EnterpriseCrud>}
              ></Route>
            </Route>
            <Route element={<ProtectedRoutes allowedRoles={["admin"]} />}>
              <Route
                exact
                path="/enterprises/create"
                element={<EnterpriseSave />}
              ></Route>
            </Route>
            <Route element={<ProtectedRoutes allowedRoles={["admin"]} />}>
              <Route
                exact
                path="/enterprises/view"
                element={<ViewEnterpise></ViewEnterpise>}
              ></Route>
            </Route>
        
            <Route
              element={<ProtectedRoutes allowedRoles={["admin", "ops_user"]} />}
            >
              <Route path="/ops-automation-tools" element={<ToolList />} />
            </Route>

            <Route
              element={<ProtectedRoutes allowedRoles={["admin", "ops_user"]} />}
            >
              <Route
                path="/ops-automation-downloads"
                element={<MyDownloads />}
              />
            </Route>
            <Route element={<ProtectedRoutes allowedRoles={["admin"]} />}>
              <Route
                exact
                path="/add-template"
                element={<AddTemplate />}
              ></Route>
            </Route>
            <Route element={<ProtectedRoutes allowedRoles={["admin"]} />}>
              <Route
                exact
                path="/edit-template"
                element={<EditTemplate />}
              ></Route>
            </Route>
            <Route
              element={<ProtectedRoutes allowedRoles={["admin", "ops_user"]} />}
            >
              <Route
                path="/template"
                element={<Preview />}
              />
            </Route>
            <Route
              element={<ProtectedRoutes allowedRoles={["admin", "ops_user"]} />}
            >
              <Route path="/ops-automation-tools/:id" element={<ToolList />} />
            </Route>
          </Routes>
        </div>
      </Box>
    </Box>
  );
}
